/* eslint no-underscore-dangle: 0 */
import React from 'react';
import { connect } from 'react-redux';
import { list } from '~/actions/bundles';
import { Button } from 'react-toolbox/lib/button';
import Bundle from '~/components/Bundle';
import Spinner from '~/components/Spinner';

import style from './style.scss';

class Bundles extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired,
    router: React.PropTypes.object.isRequired,
    dialogPush: React.PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      results: [],
      query: ''
    };
  }

  componentDidMount() {
    this.search();
  }

  search() {
    this.setState({ loading: true });
    list(
      this.props.dispatch,
      this.context.apiClient,
      this.state.query
    )
      .then(r => {
        this.setState({
          results: r.data.results.map(i => i.id),
          skipId: r.data.skipId,
          more: r.data.more,
          loading: false,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  }

  loadMore() {
    this.setState({ loading: true });
    list(
      this.props.dispatch,
      this.context.apiClient,
      this.state.query,
      this.state.skipId,
    )
      .then(r => this.setState({
        results: [...this.state.results, ...r.data.results.map(i => i.id)],
        skipId: r.data.skipId,
        more: r.data.more,
        loading: false,
      }))
      .catch(() => {
        this.setState({ loading: false });
      });
  }

  render() {
    return (
      <div style={{ padding: '10px' }}>
        <div className={style.title}>Bundles</div>
        <Button
          label="New Bundle"
          onClick={() => this.context.dialogPush('bundleNew', { onCreate: () => this.search() })}
          raised
          primary
          className={style.buttonNew}
          icon="add"
        />
        <form onSubmit={e => { e.preventDefault(); this.setState({ skipId: null }); this.search(); }} style={{ marginBottom: '10px' }}>
          <input
            placeholder="Search SKU, TYPE and ID"
            className={style.searchField}
            value={this.state.query}
            onChange={e => this.setState({ query: e.target.value })}
          />
          <Button label="Find" primary raised type="submit" />
        </form>
        {this.state.results.map(id => <Bundle id={id} key={id} style={{ margin: '0 10px 10px 0' }} />)}
        {this.state.loading && <div><Spinner className={style.spinner} /></div>}
        {!this.state.loading && <div style={{ paddingTop: '10px' }}>
          {this.state.results.length === 0 && !this.state.loading && <div>No results found</div>}
          {!this.state.loading && this.state.more && <Button
            label="Load more"
            disabled={this.state.loading}
            primary
            raised
            onClick={() => this.loadMore()}
            className={style.buttonLoadMore}
          />}
        </div>}
      </div>
    );
  }
}

export default connect()(Bundles);



// WEBPACK FOOTER //
// ./app/pages/Bundles/index.js